// src/react-bootstrap.js — Phase C.3 of the Vite/esbuild migration.
//
// Sets globalThis.React + globalThis.ReactDOM so the legacy module-level
// destructures (`const { useState: useStateNav } = React;`) continue to
// resolve under Vite + @vitejs/plugin-react with the automatic JSX
// runtime. Without this shim, every component that does
// `const { useState } = React;` at the top of its module would throw
// `ReferenceError: React is not defined` at boot.
//
// Why a shim instead of refactoring each component? The migration's
// top-level goal is to swap the build chain (CDN React + Babel-Standalone
// → Vite-bundled React-prod) without touching the legacy `window.<Name>`
// + `useStateXxx` aliasing pattern. A separate ESM-migration plan
// rewrites every `src/*.jsx` to use proper imports; that work is out of
// scope here.
//
// Both entry files (`src/main.entry.js`, `src/case-study.entry.js`) MUST
// import this shim FIRST — before any component module — so the globals
// exist by the time the legacy destructures execute.
import * as React from "react";
import * as ReactDOMClient from "react-dom/client";

globalThis.React = React;

// `src/App.jsx` and `src/CaseStudyApp.jsx` end with
// `ReactDOM.createRoot(document.getElementById("root")).render(<App />);`
// — expose `createRoot` on a `ReactDOM` global to keep that line working.
globalThis.ReactDOM = { createRoot: ReactDOMClient.createRoot };
